//DARK MODE
export const midnight = '#011638';  
export const twilight = '#0F2A54'; 
export const dusk = '#123772';
export const storm = '#314A72';
export const moonset = '#BEB8EB';

export const midnight_transparent = 'rgb(1, 22, 56, .5)';

//Scroll Bar colors
export const D_TRACK = midnight;
export const D_THUMB = twilight;

//NavBar colors
export const D_NAV_BAR_HOVER = moonset;
export const D_NAV_BAR_HEADER = storm;
export const D_NAV_BAR_ACTIVE = moonset;
export const D_NAV_BAR_SHADOW_SAFARI = storm;
export const D_NAV_BAR_BACKGROUND = midnight;

//Contact page colors
export const D_CONTACT_MEDIUM = moonset;
export const D_CONTACT_MEDIUM_HOVER = storm;
export const D_CONTACT_HEADER = moonset;

//Logo colors
export const D_LOGO_BACKGROUND_HOVER = midnight;
export const D_LOGO_BACKGROUND = midnight_transparent;
export const D_LOGO_TEXT = storm;
export const D_LOGO_TEXT_HOVER = moonset;
export const D_LOGO_EMPHASIS = moonset;
export const D_LOGO_EMPHASIS_HOVER = storm;
export const D_LOGO_BACKGROUND_SAFARI = midnight;


//Page backgrounds
export const D_TITLE_BACKGROUND = storm;
export const D_SUBTITLE_BACKGROUND = dusk;
export const D_ACCENT_BACKGROUND = twilight;
export const D_PAGE_BACKGROUND = midnight;
export const D_CONTACT_BACKGROUND = dusk;
export const D_FOOTER_BACKGROUND = twilight;

//Text
export const D_HEADER_TEXT = moonset;
export const D_TITLE_TEXT = moonset;
export const D_FOOTER_TEXT = moonset;



//LIGHT MODE
export const sand = '#FCF9EA';
export const tangerine = '#FF8A5C';
export const teal = '#49BEB7';
export const sky = '#BADFDB';

export const sand_transparent = 'rgb(252,249,234, .6)';

//Scroll Bar colors
export const TRACK = sand;
export const THUMB = tangerine;

//NavBar colors
export const NAV_BAR_HOVER = tangerine;
export const NAV_BAR_HEADER = teal;
export const NAV_BAR_ACTIVE = tangerine;
export const NAV_BAR_SHADOW_SAFARI = sky;
export const NAV_BAR_BACKGROUND = sand;

//Contact page colors
export const CONTACT_MEDIUM = sand;
export const CONTACT_MEDIUM_HOVER = teal;
export const CONTACT_HEADER = sand;


//Logo colors
export const LOGO_BACKGROUND = sand_transparent;
export const LOGO_TEXT = teal;
export const LOGO_TEXT_HOVER = tangerine;
export const LOGO_EMPHASIS = tangerine;
export const LOGO_EMPHASIS_HOVER = teal;
export const LOGO_BACKGROUND_HOVER = sand;
export const LOGO_BACKGROUND_SAFARI = sand;

//Page backgrounds
export const TITLE_BACKGROUND = sky;
export const SUBTITLE_BACKGROUND = teal;
export const ACCENT_BACKGROUND = tangerine;
export const PAGE_BACKGROUND = sand;
export const CONTACT_BACKGROUND = teal;
export const FOOTER_BACKGROUND = tangerine;

//Text
export const HEADER_TEXT = teal;
export const TITLE_TEXT = sand;
export const FOOTER_TEXT = sand;


